import type { CatalogItem, ContentKind, Page } from '@viva/core';
import type { CatalogApi } from '@viva/data';

/** A category as far as paging is concerned. */
export interface CategorySlice {
  key: string;
  itemCount: number;
}

/**
 * Lists a page of items from several categories as if they were one list, in
 * the given category order. Used for "All" when a language or country filter
 * leaves only some categories.
 */
export async function listAcross(
  catalog: Pick<CatalogApi, 'listItems'>,
  sourceId: string,
  kind: ContentKind,
  categories: CategorySlice[],
  offset: number,
  limit: number,
): Promise<Page<CatalogItem>> {
  const total = categories.reduce((sum, category) => sum + category.itemCount, 0);
  const items: CatalogItem[] = [];
  let start = 0;
  for (const category of categories) {
    if (items.length >= limit) break;
    const end = start + category.itemCount;
    const from = offset + items.length;
    if (from < end) {
      const page = await catalog.listItems({ sourceId, kind, categoryKey: category.key, offset: from - start, limit: limit - items.length });
      items.push(...page.items);
    }
    start = end;
  }
  return { items, offset, total };
}
